// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   FiUpload, FiFile, FiX, FiCheckCircle,
//   FiAlertCircle, FiRefreshCw,
// } from 'react-icons/fi';
// import { uploadGR, uploadIR, getUploadHistory } from '../../utils/grirApi';

// const formatDate = (str) =>
//   str ? new Date(str).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
// const formatSize = (b) => (b > 1024 ? `${(b / 1024).toFixed(1)} KB` : `${b} B`);

// const rowVariants = {
//   hidden: { opacity: 0, x: -10 },
//   visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 200, damping: 24 } },
// };
// const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.05 } } };

// const GRIRUpload = () => {
//   const [fileType, setFileType] = useState('GR');
//   const [selectedFiles, setSelectedFiles] = useState([]);
//   const [dragOver, setDragOver] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [result, setResult] = useState(null);
//   const [uploadError, setUploadError] = useState('');
//   const [history, setHistory] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(true);
//   const fileInputRef = useRef();

//   const loadHistory = useCallback(() => {
//     setHistoryLoading(true);
//     getUploadHistory({ limit: 50 })
//       .then(setHistory)
//       .catch(() => { })
//       .finally(() => setHistoryLoading(false));
//   }, []);

//   useEffect(() => { loadHistory(); }, [loadHistory]);

//   const addFiles = (incoming) => {
//     const valid = Array.from(incoming).filter((f) => /\.(xlsx|xls)$/i.test(f.name));
//     if (valid.length) setSelectedFiles((prev) => [...prev, ...valid]);
//   };

//   const handleDrop = (e) => {
//     e.preventDefault();
//     setDragOver(false);
//     addFiles(e.dataTransfer.files);
//   };

//   const handleFileChange = (e) => {
//     addFiles(e.target.files);
//     if (fileInputRef.current) fileInputRef.current.value = '';
//   };

//   const removeFile = (index) => {
//     setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
//   };

//   const handleUpload = async () => {
//     if (!selectedFiles.length) return;
//     setUploading(true);
//     setResult(null);
//     setUploadError('');
//     try {
//       const data = await (fileType === 'GR' ? uploadGR(selectedFiles) : uploadIR(selectedFiles));
//       setResult(data);
//       setSelectedFiles([]);
//       if (fileInputRef.current) fileInputRef.current.value = '';
//       loadHistory();
//     } catch (err) {
//       setUploadError(err.message);
//     } finally {
//       setUploading(false);
//     }
//   };

//   return (
//     <div className="grir-upload-page">
//       {/* ── Upload form ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div className="grir-card-title">
//             <FiUpload size={16} />
//             <span>Upload Excel Files</span>
//           </div>
//           <div className="grir-type-toggle">
//             <button className={`grir-type-btn ${fileType === 'GR' ? 'active' : ''}`} onClick={() => setFileType('GR')}>GR</button>
//             <button className={`grir-type-btn ${fileType === 'IR' ? 'active' : ''}`} onClick={() => setFileType('IR')}>IR</button>
//           </div>
//         </div>

//         {/* Drop zone */}
//         <motion.div
//           className={`grir-dropzone ${dragOver ? 'drag-over' : ''} ${selectedFiles.length ? 'has-file' : ''}`}
//           onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
//           onDragLeave={() => setDragOver(false)}
//           onDrop={handleDrop}
//           onClick={() => fileInputRef.current.click()}
//           animate={{ scale: dragOver ? 1.02 : 1 }}
//           transition={{ type: 'spring', stiffness: 300, damping: 22 }}
//         >
//           <input ref={fileInputRef} type="file" accept=".xlsx,.xls" multiple style={{ display: 'none' }} onChange={handleFileChange} />

//           <AnimatePresence mode="wait">
//             {selectedFiles.length > 0 ? (
//               <motion.div
//                 key="files"
//                 className="grir-file-list"
//                 initial={{ opacity: 0, scale: 0.97 }}
//                 animate={{ opacity: 1, scale: 1 }}
//                 exit={{ opacity: 0, scale: 0.95 }}
//                 transition={{ type: 'spring', stiffness: 300, damping: 22 }}
//                 onClick={(e) => e.stopPropagation()}
//               >
//                 <div className="grir-file-list-header">
//                   <FiFile size={14} style={{ color: '#22c55e' }} />
//                   <span>{selectedFiles.length} file{selectedFiles.length > 1 ? 's' : ''} selected</span>
//                   <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#94a3b8' }}>Click the zone to add more</span>
//                 </div>
//                 <div className="grir-file-list-items">
//                   {selectedFiles.map((file, i) => (
//                     <div key={i} className="grir-file-item">
//                       <FiFile size={13} style={{ color: '#0099b0', flexShrink: 0 }} />
//                       <span className="grir-file-name">{file.name}</span>
//                       <span className="grir-file-size">{formatSize(file.size)}</span>
//                       <button
//                         className="grir-remove-file"
//                         onClick={(e) => { e.stopPropagation(); removeFile(i); }}
//                         title="Remove"
//                       >
//                         <FiX size={12} />
//                       </button>
//                     </div>
//                   ))}
//                 </div>
//               </motion.div>
//             ) : (
//               <motion.div
//                 key="empty"
//                 style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}
//                 initial={{ opacity: 0, y: 6 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 exit={{ opacity: 0, y: -6 }}
//               >
//                 <div className="grir-drop-icon-wrap">
//                   <FiUpload size={26} color="#fff" />
//                 </div>
//                 <p className="grir-drop-text">Drag &amp; drop <strong>.xlsx / .xls</strong> files here</p>
//                 <p className="grir-drop-subtext">or click to browse — multiple files supported</p>
//                 <p className="grir-drop-type">File type: <strong>{fileType}</strong></p>
//               </motion.div>
//             )}
//           </AnimatePresence>
//         </motion.div>

//         {/* Feedback */}
//         <AnimatePresence>
//           {uploadError && (
//             <motion.div
//               key="err"
//               className="grir-feedback error"
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: 'auto' }}
//               exit={{ opacity: 0, height: 0 }}
//             >
//               <FiAlertCircle size={14} /><span>{uploadError}</span>
//             </motion.div>
//           )}
//           {result && (
//             <motion.div
//               key="ok"
//               className="grir-feedback success"
//               initial={{ opacity: 0, height: 0 }}
//               animate={{ opacity: 1, height: 'auto' }}
//               exit={{ opacity: 0, height: 0 }}
//             >
//               <FiCheckCircle size={14} />
//               <span>Uploaded — <strong>{result.records_count} records</strong>. Batch: <code>{result.batch_id}</code></span>
//             </motion.div>
//           )}
//         </AnimatePresence>

//         <div className="grir-card-footer">
//           <motion.button
//             className="grir-btn primary"
//             onClick={handleUpload}
//             disabled={!selectedFiles.length || uploading}
//             whileTap={{ scale: 0.96 }}
//           >
//             {uploading
//               ? (<><div className="grir-btn-spinner" /> Uploading…</>)
//               : (<><FiUpload size={14} /> Upload {selectedFiles.length > 1 ? `${selectedFiles.length} Files` : 'File'}</>)
//             }
//           </motion.button>
//         </div>
//       </motion.div>

//       {/* ── Upload history ── */}
//       <motion.div
//         className="grir-card"
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ delay: 0.14, duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
//       >
//         <div className="grir-card-header">
//           <div className="grir-card-title">
//             <FiRefreshCw size={16} />
//             <span>Upload History</span>
//           </div>
//           <motion.button className="grir-icon-btn" onClick={loadHistory} title="Refresh" whileTap={{ rotate: 180 }} transition={{ duration: 0.4 }}>
//             <FiRefreshCw size={14} />
//           </motion.button>
//         </div>

//         {historyLoading ? (
//           <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Loading history…</span></div>
//         ) : history.length === 0 ? (
//           <div className="grir-empty">No uploads found.</div>
//         ) : (
//           <div className="grir-table-wrap">
//             <table className="grir-table">
//               <thead>
//                 <tr>
//                   <th>Batch ID</th><th>Filename</th><th>Type</th>
//                   <th>Records</th><th>Size</th><th>Status</th><th>Date</th>
//                 </tr>
//               </thead>
//               <motion.tbody variants={containerVariants} initial="hidden" animate="visible">
//                 {history.map((u) => (
//                   <motion.tr key={u.id} variants={rowVariants}>
//                     <td className="grir-mono">{u.batch_id}</td>
//                     <td className="grir-filename" title={u.filename}>{u.filename}</td>
//                     <td><span className={`grir-badge type-${u.file_type.toLowerCase()}`}>{u.file_type}</span></td>
//                     <td>{u.records_count}</td>
//                     <td>{formatSize(u.file_size)}</td>
//                     <td><span className={`grir-badge status-${u.status}`}>{u.status}</span></td>
//                     <td>{formatDate(u.upload_date)}</td>
//                   </motion.tr>
//                 ))}
//               </motion.tbody>
//             </table>
//           </div>
//         )}
//       </motion.div>
//     </div>
//   );
// };

// export default GRIRUpload;



import React, { useState, useEffect, useRef, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FiUpload, FiFile, FiX, FiCheckCircle,
  FiAlertCircle, FiRefreshCw,
} from 'react-icons/fi';
import { useGrirApi } from './GrirApiContext';

const formatDate = (str) =>
  str ? new Date(str).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';
const formatSize = (b) => (b > 1024 ? `${(b / 1024).toFixed(1)} KB` : `${b} B`);

const rowVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0, transition: { type: 'spring', stiffness: 200, damping: 24 } },
};
const containerVariants = { hidden: {}, visible: { transition: { staggerChildren: 0.05 } } };

const GRIRUpload = () => {
  const { uploadGR, uploadIR, getUploadHistory } = useGrirApi();
  const [fileType, setFileType] = useState('GR');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [uploadError, setUploadError] = useState('');
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(true);
  const fileInputRef = useRef();

  const loadHistory = useCallback(() => {
    setHistoryLoading(true);
    getUploadHistory({ limit: 50 })
      .then(setHistory)
      .catch(() => { })
      .finally(() => setHistoryLoading(false));
  }, []);

  useEffect(() => { loadHistory(); }, [loadHistory]);

  const addFiles = (incoming) => {
    const valid = Array.from(incoming).filter((f) => /\.(xlsx|xls)$/i.test(f.name));
    if (valid.length) setSelectedFiles((prev) => [...prev, ...valid]);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    addFiles(e.dataTransfer.files);
  };

  const handleFileChange = (e) => {
    addFiles(e.target.files);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const removeFile = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleUpload = async () => {
    if (!selectedFiles.length) return;
    setUploading(true);
    setResult(null);
    setUploadError('');
    try {
      const data = await (fileType === 'GR' ? uploadGR(selectedFiles) : uploadIR(selectedFiles));
      setResult(data);
      setSelectedFiles([]);
      if (fileInputRef.current) fileInputRef.current.value = '';
      loadHistory();
    } catch (err) {
      setUploadError(err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="grir-upload-page">
      {/* ── Upload form ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div className="grir-card-title">
            <FiUpload size={16} />
            <span>Upload Excel Files</span>
          </div>
          <div className="grir-type-toggle">
            <button className={`grir-type-btn ${fileType === 'GR' ? 'active' : ''}`} onClick={() => setFileType('GR')}>GR</button>
            <button className={`grir-type-btn ${fileType === 'IR' ? 'active' : ''}`} onClick={() => setFileType('IR')}>IR</button>
          </div>
        </div>

        {/* Drop zone */}
        <motion.div
          className={`grir-dropzone ${dragOver ? 'drag-over' : ''} ${selectedFiles.length ? 'has-file' : ''}`}
          onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={handleDrop}
          onClick={() => fileInputRef.current.click()}
          animate={{ scale: dragOver ? 1.02 : 1 }}
          transition={{ type: 'spring', stiffness: 300, damping: 22 }}
        >
          <input ref={fileInputRef} type="file" accept=".xlsx,.xls" multiple style={{ display: 'none' }} onChange={handleFileChange} />

          <AnimatePresence mode="wait">
            {selectedFiles.length > 0 ? (
              <motion.div
                key="files"
                className="grir-file-list"
                initial={{ opacity: 0, scale: 0.97 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ type: 'spring', stiffness: 300, damping: 22 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="grir-file-list-header">
                  <FiFile size={14} style={{ color: '#22c55e' }} />
                  <span>{selectedFiles.length} file{selectedFiles.length > 1 ? 's' : ''} selected</span>
                  <span style={{ marginLeft: 'auto', fontSize: '11px', color: '#94a3b8' }}>Click the zone to add more</span>
                </div>
                <div className="grir-file-list-items">
                  {selectedFiles.map((file, i) => (
                    <div key={i} className="grir-file-item">
                      <FiFile size={13} style={{ color: '#0099b0', flexShrink: 0 }} />
                      <span className="grir-file-name">{file.name}</span>
                      <span className="grir-file-size">{formatSize(file.size)}</span>
                      <button
                        className="grir-remove-file"
                        onClick={(e) => { e.stopPropagation(); removeFile(i); }}
                        title="Remove"
                      >
                        <FiX size={12} />
                      </button>
                    </div>
                  ))}
                </div>
              </motion.div>
            ) : (
              <motion.div
                key="empty"
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}
                initial={{ opacity: 0, y: 6 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -6 }}
              >
                <div className="grir-drop-icon-wrap">
                  <FiUpload size={26} color="#fff" />
                </div>
                <p className="grir-drop-text">Drag &amp; drop <strong>.xlsx / .xls</strong> files here</p>
                <p className="grir-drop-subtext">or click to browse — multiple files supported</p>
                <p className="grir-drop-type">File type: <strong>{fileType}</strong></p>
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>

        {/* Feedback */}
        <AnimatePresence>
          {uploadError && (
            <motion.div
              key="err"
              className="grir-feedback error"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
            >
              <FiAlertCircle size={14} /><span>{uploadError}</span>
            </motion.div>
          )}
          {result && (
            <motion.div
              key="ok"
              className="grir-feedback success"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
            >
              <FiCheckCircle size={14} />
              <span>Uploaded — <strong>{result.records_count} records</strong>. Batch: <code>{result.batch_id}</code></span>
            </motion.div>
          )}
        </AnimatePresence>

        <div className="grir-card-footer">
          <motion.button
            className="grir-btn primary"
            onClick={handleUpload}
            disabled={!selectedFiles.length || uploading}
            whileTap={{ scale: 0.96 }}
          >
            {uploading
              ? (<><div className="grir-btn-spinner" /> Uploading…</>)
              : (<><FiUpload size={14} /> Upload {selectedFiles.length > 1 ? `${selectedFiles.length} Files` : 'File'}</>)
            }
          </motion.button>
        </div>
      </motion.div>

      {/* ── Upload history ── */}
      <motion.div
        className="grir-card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.14, duration: 0.38, ease: [0.22, 1, 0.36, 1] }}
      >
        <div className="grir-card-header">
          <div className="grir-card-title">
            <FiRefreshCw size={16} />
            <span>Upload History</span>
          </div>
          <motion.button className="grir-icon-btn" onClick={loadHistory} title="Refresh" whileTap={{ rotate: 180 }} transition={{ duration: 0.4 }}>
            <FiRefreshCw size={14} />
          </motion.button>
        </div>

        {historyLoading ? (
          <div className="grir-loading-inline"><div className="grir-spinner-sm" /><span>Loading history…</span></div>
        ) : history.length === 0 ? (
          <div className="grir-empty">No uploads found.</div>
        ) : (
          <div className="grir-table-wrap">
            <table className="grir-table">
              <thead>
                <tr>
                  <th>Batch ID</th><th>Filename</th><th>Type</th>
                  <th>Records</th><th>Size</th><th>Status</th><th>Date</th>
                </tr>
              </thead>
              <motion.tbody variants={containerVariants} initial="hidden" animate="visible">
                {history.map((u) => (
                  <motion.tr key={u.id} variants={rowVariants}>
                    <td className="grir-mono">{u.batch_id}</td>
                    <td className="grir-filename" title={u.filename}>{u.filename}</td>
                    <td><span className={`grir-badge type-${u.file_type.toLowerCase()}`}>{u.file_type}</span></td>
                    <td>{u.records_count}</td>
                    <td>{formatSize(u.file_size)}</td>
                    <td><span className={`grir-badge status-${u.status}`}>{u.status}</span></td>
                    <td>{formatDate(u.upload_date)}</td>
                  </motion.tr>
                ))}
              </motion.tbody>
            </table>
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default GRIRUpload;
